export var CounterSize;
(function (CounterSize) {
    CounterSize["medium"] = "medium";
    CounterSize["xSmall"] = "xSmall";
})(CounterSize || (CounterSize = {}));
//# sourceMappingURL=types.js.map